<script setup lang="ts">
import { useElementVisibility } from '@vueuse/core'
import { testimonials } from './landing-content'

const props = withDefaults(defineProps<{ tone?: 'light' | 'dark', only?: number[] }>(), { tone: 'light', only: undefined })

const items = computed(() => (props.only ? props.only.map(index => testimonials[index]!) : testimonials).slice(0, 6))

const root = useTemplateRef<HTMLElement>('root')
const near = useElementVisibility(root, { rootMargin: '400px 0px' })
const loaded = ref(false)
watch(near, (value) => { if (value) loaded.value = true }, { immediate: true })

const playing = ref<number | null>(null)
const videos = useTemplateRef<HTMLVideoElement[]>('videos')

function toggle(index: number) {
  videos.value?.forEach((video, i) => {
    if (i !== index) video.pause()
  })
  const video = videos.value?.[index]
  if (!video) return
  if (video.paused) {
    video.play()
    playing.value = index
  } else {
    video.pause()
    playing.value = null
  }
}
</script>

<template>
  <div ref="root" class="grid grid-cols-2 items-start gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
    <button
      v-for="(item, index) in items"
      :key="item.src"
      type="button"
      class="scroll-reveal group relative aspect-9/16 w-full overflow-hidden rounded-3xl text-left text-white"
      :style="index % 2 ? { marginTop: '2.5rem' } : undefined"
      :class="tone === 'dark' ? 'bg-media-surface ring-1 ring-white/10' : 'bg-neutral-900 shadow-lg'"
      :aria-label="`Видеоотзыв: ${item.name}, ${item.role}`"
      @click="toggle(index)"
    >
      <video
        ref="videos"
        :src="loaded ? `${item.src}#t=0.5` : undefined"
        :preload="loaded ? 'metadata' : 'none'"
        playsinline
        class="absolute inset-0 size-full object-cover"
        @ended="playing = null"
      />
      <div
        class="absolute inset-0 flex flex-col justify-end bg-linear-to-t from-black/80 via-black/10 to-transparent p-4 transition-opacity"
        :class="playing === index ? 'opacity-0' : 'opacity-100'"
      >
        <span class="absolute left-1/2 top-1/2 flex size-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/25 backdrop-blur transition-transform group-hover:scale-110">
          <Icon name="tabler:player-play-filled" class="size-6" />
        </span>
        <p class="text-base font-semibold leading-snug">«{{ item.quote }}»</p>
        <p class="mt-2 text-sm text-white/75">{{ item.name }}, {{ item.role }}</p>
      </div>
    </button>
  </div>
</template>
